import { render } from "./HtmlTip.vue?vue&type=template&id=84553874&scoped=true"
import script from "./HtmlTip.vue?vue&type=script&lang=js"
export * from "./HtmlTip.vue?vue&type=script&lang=js"

import "./HtmlTip.vue?vue&type=style&index=0&id=84553874&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84553874"]])

export default __exports__